import React, { useEffect, useState } from 'react';
import ServiceModal from './models/ServiceModal';
import { Service } from '../../types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { deleteService, fetchServiceAdmin, fetchServices } from '../../features/admin/serviceSlice';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import ConfirmDeleteModal from './models/ConfirmDeleteModal';
import InnerLoading from '../ui/InnerLoading';


const ServicePage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { services, loading } = useSelector((state: RootState) => state.serviceSlice);

    const [modalOpen, setModalOpen] = useState(false);
    const [editService, setEditService] = useState<Service | null>(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedServiceId, setSelectedServiceId] = useState<number | null>(null);

    useEffect(() => {
        dispatch(fetchServices());
    }, [dispatch]);

    const handleDelete = async () => {
        if (selectedServiceId !== null) {
            await dispatch(deleteService(selectedServiceId));
            dispatch(fetchServices());
            setSelectedServiceId(null);
        }
    };

const handleEdit = (serviceData: Service) => {
    dispatch(fetchServiceAdmin(serviceData.id))
        .unwrap()
        .then((data) => {
            setEditService(data); 
            setModalOpen(true);   
        })
};

    const handleAdd = () => {
        setEditService(null);
        setModalOpen(true);
    };

    const confirmDelete = (id: number) => {
        setSelectedServiceId(id);
        setDeleteModalOpen(true);

    };

    return (
        <div>
            <div className='bg-gradient-to-r from-blue-600 to-indigo-500 text-white rounded-xl shadow-md p-6 mb-6'>
                <h2 className='text-white text-lg font-semibold'>{t("Service-title")}</h2>
            </div>

            {loading ? (
                <InnerLoading />
            ) : services.length === 0 ? (
                <p className="text-center text-gray-500">{t("no-servicies")}</p>
            ) : (
                <ul className=' w-full p-4 bg-white rounded-lg grid xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-5'>
                    {services.map((service: Service) => (
                        <li key={service.id} className="border w-full rounded-xl flex flex-col justify-between p-4 shadow space-y-2">
                            <div>
                                <div className=' w-6 h-6'>
                                <img className=' w-full' src={service.image} loading="lazy" alt="service-image" title={service.title} />
                            </div>

                            <p className="text-gray-700">{service.title}</p>
                            </div>
                            

                            <div className="flex justify-end gap-3 mt-3">
                                <button
                                    onClick={() => handleEdit(service)}
                                    className="p-2 bg-yellow-100 hover:bg-yellow-200 text-yellow-700 rounded-full transition"
                                    title={t("edit")}
                                >
                                    <FiEdit size={18} />
                                </button>
                                <button
                                    onClick={() => service.id && confirmDelete(service.id)}
                                    className="p-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-full transition"
                                    title={t("delete")}
                                >
                                    <FiTrash2 size={18} />
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}

            <div className="flex justify-end w-full pt-6">
                <button
                    onClick={handleAdd}
                    className="bg-primary px-6 py-2 rounded-full text-white hover:bg-darkColor transition">
                    + {t("add-new-Service")}
                </button>
            </div>

            {modalOpen && (
                <ServiceModal
                    onClose={() => setModalOpen(false)}
                    onSuccess={() => dispatch(fetchServices())}
                    initialData={editService}
                />
            )}

            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                messageKey="delete-Service-confirm"
            />
        </div>
    );
};
export default ServicePage;
